import { ErrorMessage, FastField } from 'formik'
import React from 'react'
import ShowError from '../ShowError.jsx'

const InputField = ({
    name,
    type,
    placeholder,
    label,
    className,
    fieldClass,
    formik,
    disabled,
}) => {
    return (
        <>
            <div className={`${className || ""} flex items-center`}>
                {label && (
                    <span className="border border-gray-400 bg-gray-200 
                    border-e-0 rounded-s-md px-2 py-1 whitespace-nowrap">
                        {label}
                    </span>
                )}
                <FastField type={type}
                    name={name} placeholder={placeholder}
                    className={`border px-2 py-1 outline-none bg-transparent
                w-full focus:border-cyan-500 transition-all placeholder:text-sm
                ${!formik.touched[name] ? "border-gray-400" : formik.errors[name] ? "border-red-500" : "border-green-500"}
                ${label ? "rounded-e-md" : "rounded-md"} 
                ${fieldClass || ""}`}
                    disabled={disabled}
                />
            </div>
            <ErrorMessage name={name} component={ShowError} />
        </>
    )
}

export default InputField;